import { Navigate, createBrowserRouter } from "react-router-dom";
import PublicRoutes from "./public-wrapper";
import { lazy } from "react";
import PrivateRoutes from "./private-wrarpper";
import { paths } from "./paths";
import RootBoundary from "@/components/partials/error-boundry";

//Login page
const LoginPage = lazy(() => import("@/pages/login"));
const HomePage = lazy(() => import("@/pages/home"));

//Users page
const UsersListPage = lazy(() => import("@/pages/users/index"));
const UsersViewPage = lazy(() => import("@/pages/users/view"));
const UsersAddPage = lazy(() => import("@/pages/users/add"));

//Projects page
const ProjectsListPage = lazy(() => import("@/pages/projects/index"));
const ProjectsViewPage = lazy(() => import("@/pages/projects/view"));
const ProjectsAddPage = lazy(() => import("@/pages/projects/add"));

//Designs page
const DesignsListPage = lazy(() => import("@/pages/designs/index"));
const DesignsViewPage = lazy(() => import("@/pages/designs/view"));
const DesignsAddPage = lazy(() => import("@/pages/designs/add"));

//Sliders page
const SlidersListPage = lazy(() => import("@/pages/sliders/index"));
const SlidersViewPage = lazy(() => import("@/pages/sliders/view"));
const SlidersAddPage = lazy(() => import("@/pages/sliders/add"));

//Roles page
const RolesListPage = lazy(() => import("@/pages/roles/index"));
const RoleViewPage = lazy(() => import("@/pages/roles/view"));
const RoleAddPage = lazy(() => import("@/pages/roles/add"));

//Settings page
const SettingsListPage = lazy(() => import("@/pages/settings/index"));
const SettingsViewPage = lazy(() => import("@/pages/settings/view"));
const SettingsAddPage = lazy(() => import("@/pages/settings/add"));

//NotFound Page
const NotFoundPage = lazy(() => import("@/pages/not-found"));

const router = createBrowserRouter([
  {
    element: <PrivateRoutes />,
    errorElement: <RootBoundary />,
    children: [
      {
        path: paths.home,
        element: <Navigate to={paths.dashboard.index} />,
      },
      {
        path: paths.dashboard.index,
        element: <HomePage />,
      },
      {
        path: "users",
        children: [
          {
            path: "list",
            element: <UsersListPage />,
          },
          {
            path: "view/:id",
            element: <UsersViewPage />,
          },
          {
            path: "add",
            element: <UsersAddPage />,
          },
        ],
      },
      {
        path: "projects",
        children: [
          {
            path: "list",
            element: <ProjectsListPage />,
          },
          {
            path: "view/:id",
            element: <ProjectsViewPage />,
          },
          {
            path: "add",
            element: <ProjectsAddPage />,
          },
        ],
      },
      {
        path: "designs",
        children: [
          {
            path: "list",
            element: <DesignsListPage />,
          },
          {
            path: "view/:id",
            element: <DesignsViewPage />,
          },
          {
            path: "add",
            element: <DesignsAddPage />,
          },
        ],
      },
      {
        path: "sliders",
        children: [
          {
            path: "list",
            element: <SlidersListPage />,
          },
          {
            path: "view/:id",
            element: <SlidersViewPage />,
          },
          {
            path: "add",
            element: <SlidersAddPage />,
          },
        ],
      },
      {
        path: "roles",
        children: [
          {
            path: "list",
            element: <RolesListPage />,
          },
          {
            path: "view/:id",
            element: <RoleViewPage />,
          },
          {
            path: "add",
            element: <RoleAddPage />,
          },
        ],
      },
      {
        path: "settings",
        children: [
          {
            path: "list",
            element: <SettingsListPage />,
          },
          {
            path: "view/:id",
            element: <SettingsViewPage />,
          },
          {
            path: "add",
            element: <SettingsAddPage />,
          },
        ],
      },
    ],
  },
  {
    path: paths.login.index,
    element: <PublicRoutes />,
    errorElement: <RootBoundary />,
    children: [
      {
        index: true,
        element: <LoginPage />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
]);

export default router;
